import {ready} from '../main/utils';
import Vue from '../main/vue';
import store from '../main/vue-store';
import ProductCard from './ProductCard.vue';

ready(() => {
  const cards = document.querySelectorAll('product-card');
  if (cards.length > 0) {
    cards.forEach(el => {
      new Vue({
        el,
        comments: true,
        components: {
          ProductCard
        },
        store: store
      });
    });
  }
});
